import { render, staticRenderFns } from "./CapacityCards.vue?vue&type=template&id=71d255be&scoped=true"
import script from "./CapacityCards.vue?vue&type=script&lang=js"
export * from "./CapacityCards.vue?vue&type=script&lang=js"
import style0 from "./CapacityCards.vue?vue&type=style&index=0&id=71d255be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d255be",
  null
  
)

export default component.exports